class BlogFilter {
  constructor() {
    this.searchInput = document.querySelector('.blog-search-form input[name="q"]');

    this.init();
  }

  init() {
    this.initializeFromURL();
  }

  initializeFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const searchQuery = urlParams.get('q');

    if (searchQuery && this.searchInput) {
      this.searchInput.value = searchQuery;
    }
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BlogFilter();
  });
} else {
  new BlogFilter();
}
